import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import bulb from 'src/assets/Buy_Policy_Images/BulbGlow.svg'
import { Carousel } from 'react-responsive-carousel'
import { TIP_LIST } from 'src/utils/constants/BuyPolicy'

const Tip = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.carouselContainer}>
        <Carousel
          infiniteLoop={true}
          showArrows={false}
          showStatus={false}
          showThumbs={false}
          showIndicators={true}
          autoPlay={false}
          stopOnHover={true}
        >
          {TIP_LIST?.map((tipListItem) => (
            <div
              className={classes.container}
              key={`tipListItem_${tipListItem?.id}`}
            >
              <div>
                <img src={bulb} alt='bulb' className={classes.bulbIcon} />
              </div>
              <div className={classes.contentAction}>
                <span className={classes.content}>
                  {tipListItem?.description}
                </span>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </>
  )
}
export default Tip

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    background: 'white',
    padding: '20px',
  },
  contentAction: {
    paddingTop: '5%',
  },
  content: {
    fontSize: '13px',
    fontWeight: '400',
  },
  missionContent: {
    fontSize: '15px',
    fontWeight: '800',
    paddingLeft: '2px',
  },
  healthContent: {
    fontSize: '14px',
    fontWeight: '800',
  },
  bulbIcon: {
    width: '30px !important',
    height: '30px !important',
    animation: 'wiggle 3s linear infinite',
  },
})
